import ResetPassword from "../components/ResetPassword";

export default function ResetPasswordPage() {
  return <ResetPassword />;
}
